import { getAllAllergens } from './getAllAllergens'

export const allergens = [getAllAllergens]
